export default __webpack_public_path__ + "static/media/word.e0335e89.png";